// ============================================================================
// TYPES
// ============================================================================

export interface Note {
  id: string;
  title: string;
  text: string;
  type: string;
  labelColor?: string;
  createdAt: string;
  lastEdited?: string;
  updatedAt?: string;
  consultationTranscript?: string | null;
  procedureTranscript?: string | null;
  consultationDuration?: number | null;
  procedureDuration?: number | null;
}

export interface Folder {
  id: string;
  name: string;
  type: string;
  notes: Note[];
  noteCount?: number;
  // Patient Details
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  email?: string;
  homeAddress?: string;
  // Medical History
  medicalHistorySummary?: string;
  medicalHistoryLastUpdated?: string;
  medicalHistoryLastNoteId?: string;
}

export interface GeneratedSummary {
  summary: string;
  folderName: string;
  folderType: string;
  notesCount: number;
  generatedAt: string;
}

export interface SortOption {
  label: string;
  value: string;
}

export interface Doctor {
  id: string;
  name: string;
  surname: string;
  email: string;
}

// ============================================================================
// CONSTANTS
// ============================================================================

// Consultation types, colors, and label helpers are now centralized in:
// src/config/specialtyConsultationConfig.ts
// Use getConsultationColor() from there instead of getConsultationLabelColor()

export const sortOptions: SortOption[] = [
  { label: "Date Created (Newest)", value: "created_desc" },
  { label: "Date Created (Oldest)", value: "created_asc" },
  { label: "Last Edited (Newest)", value: "edited_desc" },
  { label: "Last Edited (Oldest)", value: "edited_asc" },
  { label: "Title (A-Z)", value: "title_asc" },
  { label: "Title (Z-A)", value: "title_desc" },
];

export const standardNoteTypes = [
  "Patient Consultation",
  "Treatment Notes",
  "Follow-up Call",
  "Referral",
  "Lab Results",
];

import { AUDIO_SERVER_URL } from "../config/urls";

export const SERVER_URL = AUDIO_SERVER_URL;
